<div class="page-wrapper">
  <app-web-navbar></app-web-navbar>

  <div class="content-grow">
    <div class="container py-4">

      <h3 class="fw-bold mb-4">📦 My Orders</h3>

      <!-- LOADING -->
      <div *ngIf="loading" class="text-center">
        <div class="spinner-border text-danger"></div>
      </div>

      <!-- NO ORDERS -->
      <div *ngIf="!loading && orders.length === 0" class="text-center text-muted py-5">
        <img src="assets/img/new/empty-card.png" alt="No Orders" class="img-fluid mb-3"
          style="max-width: 200px; opacity: 0.6;">
        <h5>No orders found.</h5>
        <p>You haven't placed any orders yet.</p>
      </div>

      <!-- ORDER LIST -->
      <div *ngFor="let order of orders" class="order-card mb-4">

        <!-- ORDER HEADER -->
        <div class="order-header d-flex justify-content-between flex-wrap">
          <div>
            <div class="fw-bold">Order #{{ order.orderNumber }}</div>
            <small>Placed on {{ formatDate(order.createdAt) }}</small>
          </div>

          <div>
            <span class="badge status-badge" [ngClass]="{
                    'bg-red': order.orderStatus === 'PLACED',
                    'bg-dark': order.orderStatus === 'PROCESSING',
                    'bg-warning': order.orderStatus === 'PACKED',
                    'bg-primary': order.orderStatus === 'SHIPPED',
                    'bg-success': order.orderStatus === 'DELIVERED',
                    'bg-danger': order.orderStatus === 'CANCELLED'
                  }">
              {{ order.orderStatus }}
            </span>
          </div>
        </div>

        <!-- PRODUCTS -->
        <div *ngFor="let item of order?.orderItems" class="product-row d-flex">

          <div class="flex-grow-1">
            <div class="fw-semibold">{{ item.productName }}</div>
            <small class="text-muted">Size: {{ item.size }}</small><br>
            <small>Qty: {{ item.quantity }}</small>
          </div>

          <div class="text-end">
            ₹{{ item.totalPrice }}
          </div>

        </div>

        <hr>

        <!-- DELIVERY + TRACKING -->
        <div class="row">

          <div class="col-md-6">
            <div class="fw-semibold">Delivery Address</div>
            <small>
              {{ order?.deliveryAddress?.name }},
              {{ order?.deliveryAddress?.streetName }},
              {{ order?.deliveryAddress?.city }},
              {{ order?.deliveryAddress?.state }} -
              {{ order?.deliveryAddress?.pinCode }}
            </small>
          </div>

          <div class="col-md-6 text-md-end mt-3 mt-md-0">

            <div><strong>Shipping Tracking ID:</strong> {{ order.trackingNumber || '-' }}</div>

            <div><strong>Order Type:</strong> {{ order.orderType || '-' }}</div>

            <div><strong>Payment Method:</strong> {{ order.transactionDetails?.paymentMethod || '-' }}</div>

            <!-- Product Total -->
            <div>
              <strong>Product Total:</strong> ₹{{ order.subTotal || 0 }}
            </div>

            <!-- If PREPAID -->
            <div *ngIf="order.orderType === 'PREPAID'" class="text-success">
              <strong>Paid Amount:</strong> ₹{{ order.totalAmount }}
            </div>

            <!-- If COD -->
            <div *ngIf="order.orderType === 'COD'">
              <div class="text-success">
                <strong>Paid Amount:</strong> ₹{{ order.transactionDetails.amount || 0 }}
              </div>
              <div class="text-danger">
                <strong>Payable on Delivery:</strong> ₹{{ order.totalAmount || 0 }}
              </div>
            </div>

            <div class="fw-bold text-danger mt-1">
              Total ₹{{ order.totalAmount }}
            </div>

          </div>

        </div>
      </div>
    </div>

    <app-web-footer></app-web-footer>
  </div>